import { FornecedorService } from './../fornecedor/fornecedor.service';
import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { Canal } from './canal.model';
import { NTECH_API } from '../app.api';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-canal',
  templateUrl: './canal.component.html',
  styleUrls: ['./canal.component.css']
})
export class CanalComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  listaCanal: CustomStore;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  listaForm = {Id: 'listaFornecedor', status: false};
  listaFornecedor = [];
  colunasGridCanal = [];
  loadingVisible = false;

  editOptionsGridCanal = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Canal',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    fornecedoreService: FornecedorService
  ) {
    this.loadingVisible = true;

    fornecedoreService.getFornecedores().subscribe(fornecedores => {
      this.listaFornecedor = fornecedores;
      this.verificarListasCarregadas('listaFornecedor');
    },
    error => {
      this.verificarListasCarregadas('listaFornecedor');
    });


    this.listaCanal = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/canal/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/canal/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/canal/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/canal/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      this.listaForm.status = true;
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if (this.listaForm.status === true) {

      this.colunasGridCanal = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'DescricaoCanal',
          dataType: 'string',
          caption: 'Descrição',
          validationRules: [{
            type: 'required',
            message: 'Descrição é obrigatório.'
          }]
        },
        {
          dataField: 'SAS_ID',
          dataType: 'number',
          caption: 'SAS ID',
          validationRules: [{
            type: 'required',
            message: 'SAS ID é obrigatório.'
          }]
        },
        {
          dataField: 'IdPessoa',
          caption: 'Fornecedor',
          lookup: {
            dataSource: this.listaFornecedor,
            displayExpr: 'Nome',
            valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Fornecedor é obrigatório.'
          }]
        }
      ];

      this.loadingVisible = false;

      return true;
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/canal/canal.component.ts